import $ from "jquery";
import c from "common";
import Bacon from "Bacon";

var stream = new Bacon.Bus();

function getCollapible($target) {
  return $target.closest(".collapsible");
}

function initCollapsible() {
  stream.plug($(document.body).asEventStream("click", ".collapsible h5").map(c.$target).map(getCollapible));
  stream.onValue(function ($collapsible) {
    $collapsible.toggleClass("collapsed");
  });
}

export default {
  setup: c.setup(initCollapsible),
  stream: stream
};



// WEBPACK FOOTER //
// ./web/js/collapsible.js